import React, { useState, useEffect } from "react";
import axios from "axios";
import { API_URL } from "../config/apiConfig";

const FALLBACK_TESTIMONIALS = [
  {
    id: 1,
    name: "Rajesh Kumar",
    text: "CabZigo has been my go-to service for all my commute needs. Reliable, safe, and affordable. Highly recommended!",
    rating: 5,
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=200&q=80"
  },
  {
    id: 2,
    name: "Priya Sharma",
    text: "Best cab service in the city! The drivers are professional and the app is super easy to use.",
    rating: 5,
    image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=200&q=80"
  },
  {
    id: 3,
    name: "Amit Patel",
    text: "Affordable rates and excellent customer service. CabZigo is my trusted transportation partner.",
    rating: 5,
    image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=200&q=80"
  },
  {
    id: 4,
    name: "Neha Singh",
    text: "Very convenient and safe. I always feel secure using CabZigo. Great experience every time!",
    rating: 5,
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=200&q=80"
  }
];

const TestimonialSection = ({ title }) => {
  const [testimonials, setTestimonials] = useState(FALLBACK_TESTIMONIALS);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchTestimonials();
  }, []);

  const fetchTestimonials = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_URL}/content/public/testimonials?limit=10`);
      if (response.data.success && response.data.data && response.data.data.length > 0) {
        setTestimonials(response.data.data);
      } else {
        setTestimonials(FALLBACK_TESTIMONIALS);
      }
    } catch (err) {
      console.warn("Error fetching testimonials, using fallback data:", err?.message);
      setTestimonials(FALLBACK_TESTIMONIALS);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const slideInterval = setInterval(() => {
      handleNext();
    }, 3000);

    return () => clearInterval(slideInterval);
  }, [testimonials]);

  const handlePrevious = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? testimonials.length - 1 : prevIndex - 1
    );
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === testimonials.length - 1 ? 0 : prevIndex + 1
    );
  };

  const currentTestimonial = testimonials[currentIndex] || testimonials[0];

  return (
    <section className="relative py-10 md:py-24 bg-white overflow-hidden">
      <style>
        {`
          @keyframes float {
            0% { transform: translateY(0px); }
            50% { transform: translateY(-15px); }
            100% { transform: translateY(0px); }
          }
          .floating-img {
            animation: float 6s ease-in-out infinite;
          }
        `}
      </style>
      
      {/* LEFT DOODLE PATTERN */}
      <div
        className="absolute top-0 left-0 h-full w-[40%] opacity-100 pointer-events-none"
        style={{
          backgroundImage: "url('/icons/pattern.png')",
          backgroundRepeat: "no-repeat",
          backgroundSize: "110%",
          backgroundPosition: "left center",
          filter: "brightness(0.6) contrast(1.2)",
        }}
      ></div>

      {/* RIGHT DOODLE PATTERN */}
      <div
        className="absolute top-0 right-0 h-full w-[40%] opacity-100 pointer-events-none"
        style={{
          backgroundImage: "url('/icons/pattern1.png')",
          backgroundRepeat: "no-repeat",
          backgroundSize: "110%",
          backgroundPosition: "right center",
          filter: "brightness(0.6) contrast(1.2)",
        }}
      ></div>

      {/* CENTER CONTENT */}
      <div className="relative z-10 container mx-auto px-4 text-center">
        {/* HEADING */}
        <h2 className="text-3xl md:text-4xl font-bold text-gray-800">
          {title ? (
            title
          ) : (
            <>
              What Our Customers Say{" "}
              <span className="text-blue-500">Cab</span>
              <span className="text-orange-500">Zigo</span>
            </>
          )}
        </h2>

        {/* Blue Line */}
        <div className="w-64 h-2 bg-gradient-to-r from-gray-200 to-blue-600 rounded-full mx-auto mt-3"></div>

    

        {/* TESTIMONIAL CARD */}
        <div className="mt-8 md:mt-16 flex justify-center relative w-full" style={{ minHeight: "350px" }}>
          {/* BACKGROUND IMAGES CONTAINER */}
          <div className="absolute inset-0 pointer-events-none hidden md:block">
            {/* LEFT SIDE IMAGES */}
            {testimonials.length > 0 && testimonials[0].image && (
              <img
                src={testimonials[0].image}
                alt={testimonials[0].name}
                className="absolute top-[5%] left-[10%] w-14 h-14 rounded-full border-3 border-white shadow-md object-cover floating-img"
                style={{ animationDelay: '0s' }}
              />
            )}
            {testimonials.length > 1 && testimonials[1].image && (
              <img
                src={testimonials[1].image}
                alt={testimonials[1].name}
                className="absolute top-[30%] left-[2%] w-24 h-24 rounded-full border-4 border-white shadow-xl object-cover floating-img"
                style={{ animationDelay: '0.5s', animationDuration: '7s' }}
              />
            )}
            {testimonials.length > 2 && testimonials[2].image && (
              <img
                src={testimonials[2].image}
                alt={testimonials[2].name}
                className="absolute top-[65%] left-[12%] w-16 h-16 rounded-full border-3 border-white shadow-md object-cover floating-img"
                style={{ animationDelay: '1s', animationDuration: '5s' }}
              />
            )}
            {testimonials.length > 3 && testimonials[3].image && (
              <img
                src={testimonials[3].image}
                alt={testimonials[3].name}
                className="absolute top-[88%] left-[5%] w-12 h-12 rounded-full border-3 border-white shadow-sm object-cover floating-img"
                style={{ animationDelay: '1.5s' }}
              />
            )}

            {/* RIGHT SIDE IMAGES */}
            {testimonials.length > 4 && testimonials[4].image && (
              <img
                src={testimonials[4].image}
                alt={testimonials[4].name}
                className="absolute top-[5%] right-[10%] w-16 h-16 rounded-full border-3 border-white shadow-md object-cover floating-img"
                style={{ animationDelay: '0.2s', animationDuration: '8s' }}
              />
            )}
            {testimonials.length > 5 && testimonials[5].image && (
              <img
                src={testimonials[5].image}
                alt={testimonials[5].name}
                className="absolute top-[35%] right-[2%] w-20 h-20 rounded-full border-4 border-white shadow-lg object-cover floating-img"
                style={{ animationDelay: '0.7s', animationDuration: '6.5s' }}
              />
            )}
            {testimonials.length > 6 && testimonials[6].image && (
              <img
                src={testimonials[6].image}
                alt={testimonials[6].name}
                className="absolute top-[62%] right-[15%] w-14 h-14 rounded-full border-3 border-white shadow-sm object-cover floating-img"
                style={{ animationDelay: '1.2s' }}
              />
            )}
            {testimonials.length > 7 && testimonials[7].image && (
              <img
                src={testimonials[7].image}
                alt={testimonials[7].name}
                className="absolute top-[82%] right-[8%] w-24 h-24 rounded-full border-4 border-white shadow-2xl object-cover floating-img"
                style={{ animationDelay: '1.8s', animationDuration: '7.5s' }}
              />
            )}
          </div>

          <div
  className="relative z-10 max-w-2xl rounded-[30px] md:rounded-[40px] px-6 md:px-12 py-8 md:py-10 text-gray-700 shadow-2xl border border-white/50 backdrop-blur-sm self-center"
  style={{ backgroundColor: "rgba(215, 238, 221, 0.4)" }}
>
  <h3 className="text-xl font-bold mb-4 text-gray-800 tracking-tight">
    {currentTestimonial.name}
  </h3>

  {/* TEXT WRAPPER */}
  <div className="relative pl-6 pr-6">
    {/* Quote Top */}
    <div className="absolute -left-4 -top-6 text-7xl text-blue-500 opacity-20 font-serif">
      "
    </div>

    <p className="text-lg leading-relaxed italic text-gray-700">
      {currentTestimonial.text}
    </p>

    {/* Quote Bottom */}
    <div className="absolute -right-4 -bottom-10 text-7xl text-blue-500 opacity-20 font-serif rotate-180">
      "
    </div>
  </div>

  <div className="mt-8 flex justify-center gap-1">
    {[...Array(5)].map((_, i) => (
      <span key={i} className={i < (currentTestimonial.rating || 5) ? "text-yellow-400" : "text-gray-300"}>
        ★
      </span>
    ))}
  </div>
</div>
        </div>

        {/* ARROWS */}
        <div className="flex justify-center gap-6 mt-12">
          <button
            onClick={handlePrevious}
            className="w-12 h-12 rounded-full bg-white border border-gray-100 flex items-center justify-center shadow-lg hover:bg-blue-500 hover:text-white transition-all duration-300 group"
          >
            <svg className="w-5 h-5 group-hover:scale-110 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M15 19l-7-7 7-7" />
            </svg>
          </button>

          <button
            onClick={handleNext}
            className="w-12 h-12 rounded-full bg-white border border-gray-100 flex items-center justify-center shadow-lg hover:bg-blue-500 hover:text-white transition-all duration-300 group"
          >
            <svg className="w-5 h-5 group-hover:scale-110 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M9 5l7 7-7 7" />
            </svg>
          </button>
        </div>
      </div>
    </section>
  );
};

export default TestimonialSection;
